"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateParentDimensions = exports.UPDATE_PARENT_DIMENSION = void 0;
exports.UPDATE_PARENT_DIMENSION = 'UPDATE_PARENT_DIMENSION';
function updateParentDimensions(dimensions) {
    return { type: exports.UPDATE_PARENT_DIMENSION, dimensions: dimensions };
}
exports.updateParentDimensions = updateParentDimensions;
//# sourceMappingURL=chart_settings.js.map